<template>
    <div>
        <modal-wrapper :open.sync="open" title="Information" matomo-name="Bankstatus-Kein-vollwertiges-Konto">
            <p>{{ text }}</p>
            <button v-if="noAccount" @click="openContactForm" class="mt-2 w-100 btn btn--cta btn--rounded btn--icon">
                Zum Kontaktformular
            </button>
        </modal-wrapper>
    </div>
</template>

<script>
import ModalWrapper from '@/components/modal/ModalWrapper';
import EventBus from '@/eventBus';
import dimmedBankStatus from '@/data/dimmedBankStatus.json';
import { mapGetters } from 'vuex';

export default {
    name: 'BankStatusModalNoAccount',
    components: { ModalWrapper },
    data() {
        return {
            open: false,
            noAccount: false,
        };
    },
    mounted() {
        EventBus.$on('modal-bankstatus-no-account', this.openModal);
    },
    beforeDestroy() {
        EventBus.$off('modal-bankstatus-no-account');
    },
    computed: {
        ...mapGetters({
            getProductField: 'getProductField',
        }),
        text() {
            const exceptions = dimmedBankStatus.exclude;
            const productField = this.getProductField('AlltagUndWuensche_Girokonto');
            const notFullCountingAccounts = productField.products.filter((product) => {
                return exceptions.includes(product.id);
            });

            const mitarbeiter = notFullCountingAccounts.find(
                (account) => account.id === 'alltagundwuensche_girokonto_mitarbeiterkonto'
            );
            if (mitarbeiter.options.BANK || mitarbeiter.options.INTEREST) {
                return 'Herzlichen Glückwunsch! Mit Ihrem Mitarbeiterkonto profitieren Sie bereits von kostenfreien Kontoführungsgebühren.';
            }

            const jugend = notFullCountingAccounts.find(
                (account) => account.id === 'alltagundwuensche_girokonto_jugendkonto'
            );
            if (jugend.options.BANK || jugend.options.INTEREST) {
                return 'Herzlichen Glückwunsch! Bis zum Alter von 25 Jahren profitieren Sie bereits von einem Jugendkonto mit kostenloser Kontoführungsgebühr.';
            }

            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.noAccount = true;
            return 'Informieren Sie sich jetzt über das für Sie geeignete Girokonto, damit Sie die Vorteile für Ihre Finanz-und Vorsorgeplanung mit dem neuen Konto-Bonus optimal nutzen können.';
        },
    },
    methods: {
        openModal() {
            this.open = true;
            this.$matomo && this.$matomo.trackEvent('Modals', 'open', 'Bankstatus-Kein-vollwertiges-Konto');
        },
        openContactForm() {
            this.$matomo && this.$matomo.trackEvent('Modals', 'open', 'Kontaktformular');
            this.open = false;
            this.$store.commit('UPDATE_VIEW', {
                view: 'contactOverlay',
                payload: true,
            });
        },
    },
};
</script>
